import React, { useMemo } from "react";
import { Container, Header, Divider, Label, Button, Dimmer, Loader } from "semantic-ui-react";
import BookDetailTable from "./BookDetailTable";
import CommonButton from "../../../common/components/Button/Button";

const BookDetail = ({
  book,
  isAdmin,
  onUpdateClick,
  onCancleClick,
  onRegisterClick,
  isRequest,
  isApproval,
  onClickCancel,
  // 같은 묶음
  batchBooks,
  onClickBatchItem,
  // 신규 — 책별 인라인 액션 + 일괄 처리
  onPerBookAction,
  onOpenBatchModal,
  onBatchCancel,
  isBookUpdating,
  isBatch
}) => {
  // 묶음에 속한 책이면 묶음의 모든 책을 한 표에 컬럼으로 나란히, 아니면 현재 책만.
  // 현재 책이 항상 첫 번째 컬럼이 되도록 정렬.
  const books = useMemo(() => {
    if (book && book.batchNum && batchBooks && batchBooks.length > 1) {
      const current = batchBooks.find(b => b.ordNum === book.ordNum);
      const others = batchBooks.filter(b => b.ordNum !== book.ordNum);
      return current ? [current, ...others] : batchBooks;
    }
    return book ? [book] : [];
  }, [book, batchBooks]);

  const isBatchView = isBatch != null ? isBatch : books.length > 1;

  // 묶음 안 status 분포 — 일괄 버튼/모달 옵션 disable 판정용.
  const batchSummary = useMemo(() => {
    const counts = { REQUEST: 0, APPROVAL: 0, RECEIPT: 0, REJECT: 0, CANCLE: 0 };
    books.forEach(b => {
      if (counts[b.status] != null) counts[b.status] += 1;
    });
    return {
      hasRequest: counts.REQUEST > 0,
      hasApproval: counts.APPROVAL > 0,
      // 일괄 처리로 영향 줄 수 있는 책이 하나라도 있는가
      hasActionable: counts.REQUEST > 0 || counts.APPROVAL > 0
    };
  }, [books]);

  return (
    <Container style={{ padding: "6em 0em", position: "relative" }}>
      {isBookUpdating ? (
        <Dimmer active inverted>
          <Loader>처리 중...</Loader>
        </Dimmer>
      ) : null}

      <Header as="h2">
        도서 상세 조회
        {isBatchView ? (
          <Label color="blue" size="small" style={{ marginLeft: "0.6em" }}>
            묶음 {books.length}권
          </Label>
        ) : null}
      </Header>
      <Divider section />
      <BookDetailTable
        books={books}
        currentOrdNum={book && book.ordNum}
        onPickBook={onClickBatchItem}
        isAdmin={isAdmin}
        onPerBookAction={onPerBookAction}
        perBookDisabled={isBookUpdating}
      />

      {/* 묶음 일괄 처리 — admin + 묶음. 처리 가능한 책(REQUEST/APPROVAL) 없으면 비활성. */}
      {isAdmin === "Y" && isBatchView ? (
        <div style={{ marginTop: "1.5em", textAlign: "center" }}>
          <Button
            color="teal"
            disabled={isBookUpdating || !batchSummary.hasActionable}
            onClick={onOpenBatchModal}
            title={
              !batchSummary.hasActionable
                ? "처리 가능한 책이 없습니다 (모두 종료 상태)"
                : undefined
            }
          >
            묶음 일괄 처리...
          </Button>
        </div>
      ) : null}

      {/* 묶음 신청자 본인용 일괄 신청취소 — REQUEST 책이 하나라도 있을 때만 활성. */}
      {isAdmin !== "Y" && isBatchView ? (
        <div style={{ marginTop: "1.5em", textAlign: "center" }}>
          <Button
            color="red"
            basic
            disabled={isBookUpdating || !batchSummary.hasRequest}
            onClick={onBatchCancel}
            title={
              !batchSummary.hasRequest
                ? "취소할 수 있는 신청 상태의 책이 없습니다"
                : undefined
            }
          >
            묶음 전체 신청취소
          </Button>
        </div>
      ) : null}

      <div style={{ marginTop: "1.5em", textAlign: "center" }}>
        {isAdmin === "Y" && !isBatchView && (
          <CommonButton
            name="업데이트"
            onDisable={!isRequest}
            click={onUpdateClick}
            color={"blue"}
          />
        )}
        {/* 신청취소는 신청자 본인 의사 → admin 에겐 안 보임 */}
        {!isBatchView && isAdmin !== "Y" && (
          <CommonButton
            name="신청취소"
            onDisable={!isRequest}
            click={onCancleClick}
          />
        )}
        {!isBatchView && (
          <CommonButton
            name="수령등록"
            onDisable={!isApproval}
            click={onRegisterClick}
          />
        )}
        <CommonButton name="취소" color={"red"} click={onClickCancel} />
      </div>

    </Container>
  );
};

export default BookDetail;
